export default __webpack_public_path__ + "static/media/mon_rotated.be59ab7d.png";